/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import debounce from "debounce";

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class Map {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;
        let mapContainer = self.elem.querySelector('[data-google-map]');
        let apiKey = self.elem.getAttribute('data-key');

        let center = {
            lat: parseFloat(52.244605),
            lng: parseFloat(0.407366)
        };

        let markerOne = {
            id: 1,
            lat: parseFloat(self.elem.getAttribute('data-lat-1')),
            lng: parseFloat(self.elem.getAttribute('data-lng-1'))
        };

        let markerTwo = {
            id: 2,
            lat: parseFloat(self.elem.getAttribute('data-lat-2')),
            lng: parseFloat(self.elem.getAttribute('data-lng-2'))
        }

        let markers = [markerOne, markerTwo];

        // Load the Google Maps API, passing in our API key
        loadGoogleMapsApi({ key: apiKey }).then(function (googleMaps) {
            self.googleMaps = googleMaps;

            // Create the map options
            let mapOptions = {
                zoom: 11,
                center: center,
                disableDefaultUI: true,
                zoomControl: true,
                styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }],
            };

            // Create the map
            let map = new googleMaps.Map(mapContainer, mapOptions);

            // Create the bounds object, which will be configure later based on the marker locations
            let bounds = new googleMaps.LatLngBounds();

            // Create the marker objects
            for (const elem of markers) {
                if (elem.id == 1) {
                    var pinColor = "#007C6b";
                } else {
                    var pinColor = "#0059a6";
                }

                var pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";
                var labelOriginFilled =  new google.maps.Point(12,9);

                var markerImage = {
                    path: pinSVGFilled,
                    anchor: new google.maps.Point(12,17),
                    fillOpacity: 1,
                    fillColor: pinColor,
                    strokeWeight: 2,
                    strokeColor: "white",
                    scale: 2,
                    labelOrigin: labelOriginFilled
                };

                var marker = new googleMaps.Marker({
                    position: elem,
                    map: map,
                    icon: markerImage,
                    animation: google.maps.Animation.DROP
                });
            };

            // Work out the area of the map containing markers
            bounds.extend(marker.position);

            // Center the map on window resize
            window.onresize = debounce(centerMap, 200);

            function centerMap() {
                map.setCenter(bounds.getCenter());
            }

        }).catch(function (error) {
            console.error(error)
        });
    }
}

export default Map;
